import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDevices2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="devices-2, macbook, iphone, phone, connected"><path d="M22 9C22.2652 9 22.5195 9.10543 22.707 9.29297C22.8946 9.4805 23 9.73478 23 10V20C23 20.5523 22.5523 21 22 21H16C15.4477 21 15 20.5523 15 20V10C15 9.44772 15.4477 9 16 9H22Z" fill="currentColor"/><path d="M13.5 20.5H2C1.44772 20.5 1 20.0523 1 19.5V17C1 16.4477 1.44772 16 2 16H13.5V20.5Z" fill="currentColor"/><path d="M20 3C20.5523 3 21 3.44772 21 4V7.5H15C14.1716 7.5 13.5 8.17157 13.5 9V14.5H3V4C3 3.44772 3.44772 3 4 3H20Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDevices2;
